export const RevealRoot = {
  observer: null,

  prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  },

  observe(root = document) {
    const images = root.querySelectorAll("[data-reveal]")
    if (this.prefersReducedMotion() || typeof IntersectionObserver === "undefined") {
      images.forEach((image) => image.classList.add("is-color"))
      return
    }
    this.disconnect()
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible")
            this.observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.25 }
    )
    images.forEach((image) => this.observer.observe(image))
  },

  disconnect() {
    this.observer?.disconnect()
    this.observer = null
  }
}
